import type { Component } from 'solid-js'
import type { JSX } from 'solid-js/jsx-runtime'
import _MdiAlert from './mdi--alert.svg?component-solid'
import _MdiAlertCircle from './mdi--alert-circle.svg?component-solid'
import _MdiCheck from './mdi--check.svg?component-solid'
import _MdiCheckCircle from './mdi--check-circle.svg?component-solid'
import _MdiFormatListNumbers from './mdi--format-list-numbers.svg?component-solid'
import _MdiInformation from './mdi--information.svg?component-solid'
import _MdiInformationSlabSymbol from './mdi--information-slab-symbol.svg?component-solid'
import _SolarAlignHorizontalCenterBold from './solar--align-horizontal-center-bold.svg?component-solid'
import _SolarAlignLeftBold from './solar--align-left-bold.svg?component-solid'
import _SolarAlignRightBold from './solar--align-right-bold.svg?component-solid'
import _SolarAltArrowRightLinear from './solar--alt-arrow-right-linear.svg?component-solid'
import _SolarCheckCircleBoldDuotone from './solar--check-circle-bold-duotone.svg?component-solid'
import _SolarCodeBold from './solar--code-bold.svg?component-solid'
import _SolarDangerBoldDuotone from './solar--danger-bold-duotone.svg?component-solid'
import _SolarDangerCircleLinear from './solar--danger-circle-linear.svg?component-solid'
import _SolarDangerTriangleLinear from './solar--danger-triangle-linear.svg?component-solid'
import _SolarEraserBold from './solar--eraser-bold.svg?component-solid'
import _SolarFullScreenBold from './solar--full-screen-bold.svg?component-solid'
import _SolarGalleryBold from './solar--gallery-bold.svg?component-solid'
import _SolarInfoCircleBoldDuotone from './solar--info-circle-bold-duotone.svg?component-solid'
import _SolarLinkBold from './solar--link-bold.svg?component-solid'
import _SolarListBold from './solar--list-bold.svg?component-solid'
import _SolarPen2Bold from './solar--pen-2-bold.svg?component-solid'
import _SolarQuitFullScreenBold from './solar--quit-full-screen-bold.svg?component-solid'
import _SolarTextBoldBold from './solar--text-bold-bold.svg?component-solid'
import _SolarTextCrossBold from './solar--text-cross-bold.svg?component-solid'
import _SolarTextItalicBold from './solar--text-italic-bold.svg?component-solid'
import _SolarTextUnderlineBold from './solar--text-underline-bold.svg?component-solid'
import _SolarUndoLeftBold from './solar--undo-left-bold.svg?component-solid'
import _SolarUndoRightBold from './solar--undo-right-bold.svg?component-solid'

type SolarTextBoldBoldProps = JSX.SvgSVGAttributes<SVGSVGElement> & {
  size?: number | string
  color?: string
}

export const MdiFormatListNumbers: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_MdiFormatListNumbers width={size} height={size} fill={color} {...props} />
)

export const SolarTextItalicBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarTextItalicBold width={size} height={size} fill={color} {...props} />
)

export const SolarTextBoldBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarTextBoldBold width={size} height={size} fill={color} {...props} />
)

export const SolarTextUnderlineBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarTextUnderlineBold width={size} height={size} fill={color} {...props} />
)

export const SolarTextCrossBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarTextCrossBold width={size} height={size} fill={color} {...props} />
)

export const SolarListBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarListBold width={size} height={size} fill={color} {...props} />
)

export const SolarAlignLeftBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarAlignLeftBold width={size} height={size} fill={color} {...props} />
)

export const SolarAlignRightBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarAlignRightBold width={size} height={size} fill={color} {...props} />
)

export const SolarAlignHorizontalCenterBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarAlignHorizontalCenterBold width={size} height={size} fill={color} {...props} />
)

export const SolarLinkBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarLinkBold width={size} height={size} fill={color} {...props} />
)

export const SolarGalleryBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarGalleryBold width={size} height={size} fill={color} {...props} />
)

export const SolarCodeBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarCodeBold width={size} height={size} fill={color} {...props} />
)

export const SolarUndoLeftBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarUndoLeftBold width={size} height={size} fill={color} {...props} />
)

export const SolarUndoRightBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarUndoRightBold width={size} height={size} fill={color} {...props} />
)

export const SolarEraserBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarEraserBold width={size} height={size} fill={color} {...props} />
)

export const SolarPen2Bold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarPen2Bold width={size} height={size} fill={color} {...props} />
)

export const SolarQuitFullScreenBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarQuitFullScreenBold width={size} height={size} fill={color} {...props} />
)

export const SolarFullScreenBold: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarFullScreenBold width={size} height={size} fill={color} {...props} />
)

export const MdiCheck: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => <_MdiCheck width={size} height={size} fill={color} {...props} />

export const SolarDangerCircleLinear: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarDangerCircleLinear width={size} height={size} fill={color} {...props} />
)

export const SolarDangerTriangleLinear: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarDangerTriangleLinear width={size} height={size} fill={color} {...props} />
)

export const MdiInformationSlabSymbol: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_MdiInformationSlabSymbol width={size} height={size} fill={color} {...props} />
)

export const SolarCheckCircleBoldDuotone: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarCheckCircleBoldDuotone width={size} height={size} fill={color} {...props} />
)

export const SolarDangerBoldDuotone: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarDangerBoldDuotone width={size} height={size} fill={color} {...props} />
)

export const SolarInfoCircleBoldDuotone: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarInfoCircleBoldDuotone width={size} height={size} fill={color} {...props} />
)

export const MdiInformation: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_MdiInformation width={size} height={size} fill={color} {...props} />
)

export const MdiCheckCircle: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_MdiCheckCircle width={size} height={size} fill={color} {...props} />
)

export const MdiAlertCircle: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_MdiAlertCircle width={size} height={size} fill={color} {...props} />
)

export const MdiAlert: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => <_MdiAlert width={size} height={size} fill={color} {...props} />

export const SolarAltArrowRightLinear: Component<SolarTextBoldBoldProps> = ({ size = 24, color = 'currentColor', ...props }: SolarTextBoldBoldProps) => (
  <_SolarAltArrowRightLinear width={size} height={size} fill={color} {...props} />
)
